import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, IconButton, Grow } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CookieConsent = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('nextix-cookie-consent');
        if (!consent) {
            setOpen(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('nextix-cookie-consent', 'true');
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    }

    if (!open) return null;

    return (
        <Grow in={open}>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: '#2d2d2d', // Dark gray background
                    color: '#fff',
                    p: 2,
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
                    minHeight: '60px'
                }}
            >
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    maxWidth: '1200px',
                    px: 2
                }}>
                    <Box sx={{ flexGrow: 1, mr: 2 }}>
                        <Typography variant="body2" sx={{ fontSize: '13px', lineHeight: 1.5 }}>
                            We use cookies to ensure that we give you the best experience on our website. If you continue to use this site we will assume that you are happy with it.
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            onClick={handleAccept}
                            sx={{
                                backgroundColor: '#00a99d', // Teal/Green color from screenshot
                                color: '#fff',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '13px',
                                minWidth: '40px',
                                px: 2,
                                py: 0.5,
                                borderRadius: '4px',
                                '&:hover': {
                                    backgroundColor: '#008f84',
                                },
                                mr: 2
                            }}
                        >
                            Ok
                        </Button>
                        <IconButton
                            size="small"
                            onClick={handleClose}
                            sx={{ color: '#666' }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        </Grow>
    );
};

export default CookieConsent;
